import AuthenticatedImage from "./AuthenticatedImage";
import "./ArticleImageGallery.css";

const ArticleImageGallery = ({ article, variant = "thumbnail" }) => {
    if (!article) {
        return (
            <div className="tree-image-gallery empty">
                Select an article to see its images.
            </div>
        );
    }

    if (!article.images || article.images.length === 0) {
        return (
            <div className="tree-image-gallery empty">
                No images for this article.
            </div>
        );
    }

    return (
        <div className={`tree-image-gallery ${variant}`}>
            {article.images.map((img) => (
                <AuthenticatedImage
                    key={img}
                    articleId={article.id}
                    blobName={img}
                    className={`tree-image-thumb ${variant}`}
                    alt={article.name}
                />
            ))}
        </div>
    );
};

export default ArticleImageGallery;